import { ButtonsModule } from 'axis-components/components/button/button.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AxisChipComponent, AxisChipAvatarComponent } from './chip.component';
import { AxisChipListComponent } from './chip-list.component';
import { IconModule } from 'axis-components/components/icon/icon.module';
import { TooltipModule } from 'axis-components/components/tooltip/tooltip.module';

@NgModule({
  declarations: [
    AxisChipComponent,
    AxisChipListComponent,
    AxisChipAvatarComponent
  ],
  imports: [
    CommonModule,
    ButtonsModule,
    IconModule,
    TooltipModule
  ],
  exports: [
    AxisChipComponent,
    AxisChipListComponent,
    AxisChipAvatarComponent
  ]
})
export class ChipListModule { }
